module.exports = __webpack_public_path__ + "img/icon-paypal-logo.9681ce46.svg";